import { Modify } from "@biblioteksentralen/types";
import { Bibliobattles, BibliobattlesTemplateContent, Promotion } from "@libry-content/types";
import { resolveEventsReferences } from "./sommerlesGroq";
import { getTemplateContentPromotionFilter } from "../promotion/utils";
import { ResolvedRecommendation, resolveRecommendationGroqProjection } from "../recommendations";
import { ResolvedListSummary, resolveListSummary } from "../lists";
import { ResolvedEventSummary } from "../events";
import groq from "groq";

export const bibliobattlesGroqFilter = getTemplateContentPromotionFilter("bibliobattles");

export const resolveBibliobattlesGroqProjection = groq`
  ...,
  templateContent->,
  recommendations[]->{
    ${resolveRecommendationGroqProjection}
  },
  bookLists[]->{
    ${resolveListSummary}
  },
  "events": ${resolveEventsReferences},
  "promotion": templateContent->promotion,
`;

export type ResolvedBibliobattles = Modify<
  Bibliobattles,
  {
    recommendations: ResolvedRecommendation[];
    bookLists: ResolvedListSummary[];
    events: ResolvedEventSummary[] | null;
    templateContent: BibliobattlesTemplateContent;
  } & { promotion: Promotion }
>;

export const resolveBibliobattlesBannerDataGroqProjection = groq`
  _id,
  _type,
  startDate,
  endDate,
  templateContent->,
  "promotion": templateContent->promotion,
`;

export type ResolvedBibliobattlesBannerData = Pick<
  ResolvedBibliobattles,
  "_id" | "_type" | "promotion" | "startDate" | "endDate"
> & { templateContent: BibliobattlesTemplateContent };
